<script type="text/ecmascript-6">
    import Layout from '../layouts/Index.vue'
    import MainHeader from '../layouts/Header.vue'

    export default {
        name: 'Collections',

        components: {
            Layout,
            MainHeader,
        },

        metaInfo() {
            return {
                title: 'Collections',
            }
        },

        /**
         * The component's data.
         */
        data: () => ({
            loading: true,
            collections: [],
            links: {
                first: null,
                last: null,
                next: "/api/mmn/collections",
                prev: null
            },
            meta: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                to: 1,
                total: 1,
            },
        }),


        /**
         * Created the component.
         */
        created() {
            this.fetchCollections();
        },


        methods: {
            /**
             *  Get the collections.
             */
            async fetchCollections() {

                if (this.loading === true && this.links.first) {
                    this.$toast.warn({ title: 'Warning', message: 'Loading ...' });
                    return;
                }

                if (this.links.next === null) {
                    return;
                }

                this.loading = true;

                axios.get(this.links.next).then((response) => {
                    this.collections.push(...response.data.data);
                    this.links = response.data.links;
                    this.meta = response.data.meta;
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                });
            },
        }
    }
</script>

<template>
    <layout>

        <!---Main Content Start--->
        <div class="ms_content_wrapper ms_genres_single ms_profile padder_top80">

            <main-header/>

            <div class="ms_fea_album_slider padder_bottom30" id="collections">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="ms_heading">
                            <h1>Collections</h1>
                        </div>
                    </div>

                    <div v-for="collection in collections" class="cs-lg-col-8 cs-md-col-5 col-md-2 col-6">
                        <router-link :to="{ name: 'collection', params: { id: collection.uuid }}" :title="collection.name">
                            <div class="ms_genres_box">
                                <div class="ms_rcnt_box_img">
                                    <img :src="collection.image" alt="" class="img-fluid" onError="this.onerror=null;this.src='/images/album/collection_playlist.png';">
                                    <div class="ms_main_overlay">
                                        <div class="ms_box_overlay"></div>
                                    </div>
                                </div>
                                <div class="mb-3 genre_title">
                                    {{collection.name_eng}}
                                </div>
                            </div>
                        </router-link>
                    </div>

                </div>

                <div class="more_loading" v-show="loading">
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                </div>

                <div class="ms_view_more padder_bottom20" v-show="meta.current_page !== meta.last_page">
                    <a href="#" @click.prevent="fetchCollections()" class="ms_btn">view more</a>
                </div>

            </div>
        </div>


    </layout>
</template>
